import axios from 'axios';
import global from '@/Global.js';
import {Notify, Toast} from 'vant';
import router from '../router';
import {Refresh_Token} from "@/api/index";


/*是否有请求正在刷新token*/
window.isRefreshing = false;
/*被挂起的请求数组*/
let refreshSubscribers = [];

// decodeURIComponent(escape(window.atob(("-a1i-ivlSIsImV4cCI6MTU3OTUxMTY0OH0").replace(/-/g, "+").replace(/_/g, "/"))));
function isExpired(token) {
    try {
        let payLoad = JSON.parse(window.atob(token.replace(/-/g, "+").replace(/_/g, "/").split('.')[1]));
        let timestamp = new Date().getTime();
        return payLoad.expireTime < timestamp;
    }catch(e){
        console.error(e)
        return false;
    }
}

/*刷新请求（refreshSubscribers数组中的请求得到新的token之后会自执行，用新的token去请求数据）*/
function onRrefreshed(token) {
    refreshSubscribers.map(cb => cb(token))
}

/*push所有请求到数组中*/
function subscribeTokenRefresh(cb) {
    refreshSubscribers.push(cb)
}

const instance = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    withCredentials: true,
    baseURL: global.APIBasePath,
    timeout: 20000
});

// http request拦截器 添加一个请求拦截器
instance.interceptors.request.use(
    config => {
        if (!config.headers || !config.headers.notShowToast) {
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            });
        }
        // if (config.url.indexOf('/Upload/') != -1) {
        //     config.headers['Content-Type'] = 'multipart/form-data';
        // }
        config.headers.clientType = 'web'; //客户端类型
        let accessToken = localStorage.getItem("AccessToken")
        var refreshToken = localStorage.getItem("RefreshToken")
        var user = localStorage.getItem("User")

        if (!config.headers.allowAnonymous && accessToken) {
            if (!isExpired(accessToken) && user) {
                config.headers.Authorization =  accessToken; //将token放到请求头发送给服务器
            } else {
                var refreshToken = localStorage.getItem("RefreshToken")
                if (isExpired(refreshToken)) {
                    router.push("/login");
                    return;
                } else {
                    if (config.url.indexOf('Refresh') === -1) {
                        /*判断是否正在刷新*/
                        if (!window.isRefreshing) {
                            /*将刷新token的标志置为true*/
                            window.isRefreshing = true
                            /*发起刷新token的请求*/
                            Refresh_Token({"refreshToken": refreshToken}).then(res => {
                                /*将标志置为false*/
                                window.isRefreshing = false;
                                /*成功刷新token*/
                                config.headers.Authorization = res.accessToken;
                                /*更新auth*/
                                res.memberSystemId=res.systemId
                                localStorage.setItem("User", JSON.stringify(res));
                                localStorage.setItem("AccessToken", res.accessToken);
                                localStorage.setItem("RefreshToken", res.refreshToken);
                                /*执行数组里的函数,重新发起被挂起的请求*/
                                onRrefreshed(res.accessToken)
                                /*执行onRefreshed函数后清空数组中保存的请求*/
                                refreshSubscribers = []
                            }).catch(err => {
                                router.push("/login");
                            })
                        }
                        /*把请求(token)=>{....}都push到一个数组中*/
                        let retry = new Promise((resolve, reject) => {
                            /*(token) => {...}这个函数就是回调函数*/
                            subscribeTokenRefresh((token) => {
                                config.headers.Authorization = token
                                /*将请求挂起*/
                                resolve(config)
                            })
                        })
                        return retry;
                    }
                }
            }
        }
        return config;
    },
    error => {
        Toast.clear();
        console.log(error);
        return Promise.reject();
    }
);

instance.interceptors.response.use(
    response => {
        Toast.clear();
        if (response.status === 200) {
            var data = response.data;
            if (data.code == 0) {
                return data.data;
            } else if (data.message.indexOf('未登录') >= 0 || data.message.indexOf('没有登录') >= 0 || data.message.indexOf('重新登录') >= 0) {
                localStorage.removeItem("AccessToken")
                localStorage.removeItem("RefreshToken")
                localStorage.removeItem("User")
                clearInterval(+ localStorage.getItem("intervalId"))

                router.push("/login");
            }
            Notify(data.message);
        } else {
            Notify("请求异常，请重试！");
        }
        return Promise.reject();
    },
    async error => {
        Toast.clear();
        if (error.response) {
            let {status} = error.response;
            let {data} = error.response || {};
            data.message = data.message || ''
            if (status == 401 || data.message.indexOf('未登录') >= 0 || data.message.indexOf('没有登录') >= 0|| data.message.indexOf('重新登录') >= 0) {
                router.push("/login");
                return;
            } else if (data && data.code != 0) {
                Notify(data.message || "请求异常，请重试！");
            } else if (status == 500) {
                Notify("请求异常，请重试！");
            }
        }
        // Notify("请求异常，请重试！");
        console.log(error);
        return Promise.reject();
    }
);

// export default instance;

/**
 * 使用es6的export default导出了一个函数，导出的函数代替axios去帮我们请求数据，
 * 函数的参数及返回值如下：
 * @param {String} method  请求的方法：get、post、delete、put
 * @param {String} url     请求的url:
 * @param {Object} data    请求的参数
 * @returns {Promise}     返回一个promise对象，其实就相当于axios请求数据的返回值
 */
export default function (method, url, data = null, allowAnonymous = false) {
    var headers = {'allowAnonymous': allowAnonymous};
    let notShowToast=null
    for (let i = 0; i < arguments.length; i++) {
        if (typeof arguments[i] === 'object' && Object.keys(arguments[i] ).includes('notShowToast')) {
            notShowToast = arguments[i].notShowToast
            headers.notShowToast=true
        }
    }
    method = method.toLowerCase();
    if (method == 'post') {
        return instance.post(url, data)
    } else if (method == 'get') {
        return instance.get(url, {params: data, headers})
    } else if (method == 'delete') {
        return instance.delete(url, {params: data})
    } else if (method == 'put') {
        return instance.put(url, data)
    } else {
        console.error('未知的method' + method)
        return false
    }
}
